"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterPinoMessage = void 0;
const filterPinoMessage = pinoMessage => {
  const {
    pid,
    hostname,
    ...otherProperties
  } = pinoMessage;
  return otherProperties;
};
exports.filterPinoMessage = filterPinoMessage;
//# sourceMappingURL=filterPinoMessage.js.map